/**
 * useTodayEvents — shared today-events hook (Plan 03-09 D-11 + D-12).
 *
 * Called by both EventsTile (idle tablet dashboard) and TodayRoute (/i-dag).
 * Fetches GET /api/calendar/today → { events: EventInstance[] }.
 *
 * T-CAL-42: on 401, query enters error state and the caller's default `[]`
 * kicks in — idle dashboard shows "Ingen hendelser i dag", no PII leak.
 */
import { useQuery } from '@tanstack/react-query';
import { CAL_TIMINGS } from '../calendar/timings';
import type { EventInstance } from '../calendar/useCalendarRange';

export function useTodayEvents() {
  return useQuery<EventInstance[]>({
    queryKey: ['calendar', 'today'],
    queryFn: async () => {
      const res = await fetch('/api/calendar/today', { credentials: 'include' });
      if (!res.ok) throw new Error(`today fetch ${res.status}`);
      const json = (await res.json()) as { events: EventInstance[] };
      return json.events;
    },
    staleTime: 5 * 60 * 1000,                          // 5 min
    refetchInterval: CAL_TIMINGS.todayRefetchInterval,  // 30 min
  });
}
